<template>
  <div v-if="question">
    <h1>Question</h1>
    <v-btn :to="{ name: 'quoteCategory', params: { id: computedCategoryid } }">
      <v-icon>chevron_left</v-icon>Category
    </v-btn>
    <h2>{{ `Question ${$route.params.questionid}` }}</h2>
    <v-text-field
      label="Order"
      v-model="question.orderid"
      :disabled="true"
      outline
    />
    <v-textarea label="Question" v-model="question.body" outline />
    <v-textarea label="Description" v-model="question.description" outline />
    <v-textarea label="Help text" v-model="question.help" outline />
    <v-select
      label="Question type"
      v-model="question.questiontypeid"
      :items="questionTypes"
      item-value="id"
      outline
      v-if="questionTypes"
    >
      <template slot="selection" slot-scope="data">{{
        `${data.item.id} - ${data.item.name}`
      }}</template>
      <template slot="item" slot-scope="data">{{
        `${data.item.id} - ${data.item.name}`
      }}</template>
    </v-select>
    <v-text-field
      label="Default"
      v-model="question.defaultvalue"
      outline
      v-if="!computedOptions"
    />
    <v-select
      label="Default"
      v-model="question.defaultoptionid"
      :items="computedOptions"
      item-value="id"
      item-text="value"
      outline
      v-if="computedOptions"
    />
    <v-checkbox label="Locked" v-model="question.locked" />
    <v-checkbox label="Archived" v-model="question.archived" />
    <!-- <v-text-field label="Used" v-model="question.used" outline :disabled="true" /> -->
    <v-btn @click="saveQuestion"> <v-icon>save</v-icon>Save </v-btn>
    <v-btn :to="{ name: 'quoteCategory', params: { id: computedCategoryid } }"
      >Cancel</v-btn
    >
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Question",
  metaInfo() {
    return {
      title: "Question",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  computed: {
    computedOptions() {
      if (!this.question || !this.options) {
        return undefined;
      }
      const options = this.options[this.question.questiontypeid];
      return options;
    },
    computedCategoryid() {
      if (this.$route.query.categoryid) {
        return this.$route.query.categoryid;
      }
      if (!this.question) {
        return undefined;
      }
      return this.question.categoryid;
    },
  },
  data() {
    return { question: null, questionTypes: null, options: null };
  },
  methods: {
    async fetchQuestion() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/questions/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.question = response.data;
    },
    async fetchQuestionTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/questionTypes`);
      // console.log(response.data);
      this.questionTypes = response.data;
    },
    async fetchOptions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/questionTypes/options`
      );
      // console.log(response.data);
      this.options = response.data;
    },
    saveQuestion() {
      if (this.$route.params.id) {
        this.updateQuestion();
      } else {
        this.createQuestion();
      }
    },
    async createQuestion() {
      await nbmlaw.post(`/cors/admin/sales/questions`, this.question);
      this.$router.push({
        name: "quoteCategory",
        params: { id: this.computedCategoryid },
      });
    },
    async updateQuestion() {
      await nbmlaw.put(
        `/cors/admin/sales/questions/${this.$route.params.id}`,
        this.question
      );
      this.$router.push({
        name: "quoteCategory",
        params: { id: this.computedCategoryid },
      });
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchQuestion();
        } else {
          this.question = { categoryid: this.$route.query.categoryid };
        }
      },
    },
  },
  created() {
    this.fetchQuestionTypes();
    this.fetchOptions();
  },
};
</script>